// @flow

import { type CardBrand } from '@tectonics/prs/card-brand';
import { type CardMask } from './types';

export function getCardBrandMask(cardBrand: ?CardBrand): CardMask {
  switch (cardBrand) {
    case 'amex':
      return AMEX_MASK;
    case 'diners':
      return DINERS_MASK;
    default:
      return DEFAULT_MASK;
  }
}

const AMEX_MASK = [
  /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ',
  /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ',
  /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/,
];

const DINERS_MASK = [
  /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ',
  /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ',
  /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/,
];

const DEFAULT_MASK = [
  /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ',
  /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ',
  /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ',
  /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/,
];
